import { Component } from '@angular/core';

@Component({
  selector: 'mbs-install-msp-app-badges',
  templateUrl: './install-msp-app-badges.component.html',
  standalone: true
})
export class InstallMspAppBadgesComponent {}
